import { apis } from "../config";
import { Post } from "@/utils/request";
// 获取商户列表
export function getTenantList(data) {
  return Post(apis.tenant.getTenantList, data);
}
// 获取停车场列表
export function queryPageListParkLots(data) {
  return Post(apis.tenant.queryPageListParkLots, data);
}
// 获取树状图
export function treeSentryBox(data) {
  return Post(apis.tenant.treeSentryBox, data);
}
// 查询在场车辆
export function queryParkVehicle(data) {
  return Post(apis.tenant.queryParkVehicle, data);
}
// 订单查询
export function queryParkOrder(data) {
  return Post(apis.tenant.queryParkOrder, data);
}
// 人员查询
export function queryUser(data) {
  return Post(apis.tenant.queryUser, data);
}
// 订单编辑
export function updateOrder(data) {
  return Post(apis.tenant.updateOrder, data);
}
export function getOrder(data) {
  return Post(apis.tenant.getOrder, data);
}
// 折扣卷查询
export function queryDiscount(data = {}) {
  return Post(apis.tenant.queryDiscount, data);
}
// 查询道闸
export function queryParkLotGate(data = {}) {
  return Post(apis.tenant.queryParkLotGate, data);
}
// 获取过车记录
export function findPassRecord(data = {}) {
  return Post(apis.tenant.findPassRecord, data);
}

//岗亭排班时间段
export function queryUserSch(data={}){
  return Post(apis.tenant.queryUserSch,data)
}
//岗亭人员配置参数
export function curlSentryUserConfig(data={}){
  return Post(apis.tenant.curlSentryUserConfig,data)
}
//岗亭信息
export function getSentryStatement(data={}){
  return Post(apis.park.getSentryStatement,data)
}
//列出收费员有排班的所有岗亭
export function listTenantUserSentryBox(data={}){
  return Post(apis.tenant.listTenantUserSentryBox,data)
}
//列出收费员有排班的所有岗亭
export function refreshSentryCashier(data={}){
  return Post(apis.tenant.refreshSentryCashier,data)
}
// 车辆类型
export function billCarSize(data){
  return Post(apis.tenant.billCarSize,data)
}
// 重播
export function report(data){
  return Post(apis.tenant.report,data)
}
// 发布信息列表
export function listUpdateVersion(data){
  return Post(apis.tenant.listUpdateVersion,data)
}
// 发布信息列表
export function checkVersion(data){
  return Post(apis.tenant.checkVersion,data)
}
// 相机识别未开闸记录
export function queryOpenGateFailedRecord(data){
  return Post(apis.tenant.queryOpenGateFailedRecord,data)
}
